import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={20}
      height={26}
      viewBox="0 0 15 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M12.966 17.916l-.98-6.63-.074-.224h-8.79l-.058.111-1.036 6.742a.237.237 0 00.235.273h.94l.09-.04v-.026a.32.32 0 01.32-.32h.093v-1.986h7.578c.047 0 .086.038.086.085v1.902a.32.32 0 01.298.32v.026l.052.04h1.01a.237.237 0 00.236-.273z"
        fill="#C8EFFE"
      />
      <Path
        d="M2.91 18.107a.237.237 0 01-.055-.191l1.036-6.741.057-.112h-.826l-.058.112-1.036 6.74a.237.237 0 00.235.274h.827a.238.238 0 01-.18-.082z"
        fill="#99E6FC"
      />
      <Path
        d="M3.332 18.255l-.04-.106H2.264a.198.198 0 01-.195-.228l1.054-6.86h-.66c-.603 0-1.12.433-1.228 1.027L.02 18.801a1.249 1.249 0 001.23 1.47h2.043l.04-.1v-1.916z"
        fill="#57BE92"
      />
      <Path
        d="M.872 18.8l1.214-6.712c.095-.53.516-.93 1.034-1.011l.002-.015h-.66c-.603 0-1.12.432-1.228 1.026L.02 18.801a1.249 1.249 0 001.23 1.47h.85a1.249 1.249 0 01-1.228-1.47z"
        fill="#22B27F"
      />
      <Path
        d="M14.98 18.806l-1.183-6.713a1.249 1.249 0 00-1.23-1.031h-.655l1.015 6.86a.198.198 0 01-.196.227h-1.063l-.04.083v1.916l.04.124h2.083c.776 0 1.364-.701 1.23-1.466zM9.706 10.367l-.471-.345a2.6 2.6 0 01-.914.165H6.775a2.6 2.6 0 01-.927-.17l-.478.35a.208.208 0 00-.086.168v2.741c0 .177.206.273.341.16l1.78-1.478a.208.208 0 01.266 0l1.78 1.478a.208.208 0 00.34-.16v-2.741a.208.208 0 00-.085-.168z"
        fill="#57BE92"
      />
      <Path
        d="M6.39 10.2a2.631 2.631 0 01-.58-.155l-.44.322a.208.208 0 00-.086.168v2.62h.681l.168-.14V10.98c0-.066.031-.129.085-.168l.376-.274-.203-.338z"
        fill="#22B27F"
      />
      <Path
        d="M9.259 15.816v-2.537a.125.125 0 00-.125-.125H3.792a.125.125 0 00-.125.125v2.537h5.592z"
        fill="#F6A96C"
      />
      <Path
        d="M4.967 15.776V13.28c0-.07.056-.125.125-.125h-1.3a.125.125 0 00-.125.125v2.497h1.3zM4.163 7.576V5.268c-.14.118-.274.243-.403.376a.51.51 0 01-.365.156.49.49 0 01-.309-.108l-.008-.007a.5.5 0 01-.148-.196.942.942 0 00-.293.684v.867c0 .522.423.946.945.946h.614a2.619 2.619 0 01-.033-.41z"
        fill="#EA9B58"
      />
      <Path
        d="M12.167 5.489a.5.5 0 01-.148.196l-.008.007a.49.49 0 01-.31.108.51.51 0 01-.365-.156 5.347 5.347 0 00-.402-.376v2.308c0 .14-.011.276-.033.41h.614a.945.945 0 00.945-.946v-.867a.943.943 0 00-.293-.684z"
        fill="#F6A96C"
      />
      <Path
        d="M8.32 10.187H6.776c-.14 0-.277-.011-.41-.033l.974 1.621c.09.15.308.15.398 0l.973-1.617c-.127.019-.257.029-.39.029z"
        fill="#EA9B58"
      />
      <Path
        d="M7.549 4.041a5.218 5.218 0 00-3.425 1.26v2.274a2.652 2.652 0 002.652 2.652h1.546a2.652 2.652 0 002.652-2.652V5.302A5.218 5.218 0 007.549 4.04z"
        fill="#FFBD86"
      />
      <Path
        d="M5.42 7.576V4.53c-.461.205-.899.48-1.296.825v2.221a2.652 2.652 0 002.652 2.652h1.296a2.652 2.652 0 01-2.651-2.652z"
        fill="#F6A96C"
      />
      <Path
        d="M7.55 3.034c1.569 0 3.038.564 4.186 1.596v-.608C11.736 1.801 9.936 0 7.714 0h-.33a4.022 4.022 0 00-4.022 4.022v.608A6.212 6.212 0 017.55 3.034z"
        fill="#57BE92"
      />
      <Path
        d="M5.089 3.488A4.024 4.024 0 018.394.058 4.046 4.046 0 007.714 0h-.33A4.022 4.022 0 003.36 4.022v.554A6.247 6.247 0 015.09 3.488z"
        fill="#22B27F"
      />
      <Path
        d="M5.668 6.985a.297.297 0 01-.297-.297V6.07a.297.297 0 11.594 0v.618a.297.297 0 01-.297.297zM9.43 6.985a.297.297 0 01-.296-.297V6.07a.297.297 0 11.594 0v.618a.297.297 0 01-.297.297zM7.955 7.68h-.542a.422.422 0 01-.422-.422V6.07a.297.297 0 11.594 0v1.015h.37a.297.297 0 110 .594z"
        fill="#A44F3E"
      />
      <Path
        d="M3.053 5.716l.008.006a.54.54 0 00.728-.05c2.048-2.121 5.471-2.121 7.519 0a.54.54 0 00.728.05l.008-.006a.538.538 0 00.053-.792C9.622 2.35 5.475 2.35 3 4.924a.538.538 0 00.053.792z"
        fill="#C8EFFE"
      />
      <Path
        d="M4.29 4.922a6.276 6.276 0 013.904-1.896A6.303 6.303 0 003 4.922a.538.538 0 00.053.792l.008.007a.54.54 0 00.728-.05c.114-.119.232-.23.354-.335a.533.533 0 01.147-.414z"
        fill="#99E6FC"
      />
      <Path
        d="M7.548 9.087a2.215 2.215 0 01-1.576-.653.297.297 0 11.42-.42c.309.309.72.48 1.156.48.437 0 .847-.171 1.157-.48a.297.297 0 01.42.42 2.215 2.215 0 01-1.577.653z"
        fill="#A44F3E"
      />
      <Path
        d="M10.034 18.012a.17.17 0 01.17-.17h1.144c.014 0 .027.002.04.004l.021-.037v-1.907a.125.125 0 00-.125-.125H3.667v2.026l.02.04h1.07a.17.17 0 01.17.169v2.185l.04.075h5.027l.04-.069v-2.191z"
        fill="#FE7D43"
      />
      <Path
        d="M4.758 17.803c.078 0 .144.042.18.104v-2.13h-1.27v2.026h1.09z"
        fill="#FD6930"
      />
      <Path
        d="M9.994 20.272h1.675v-2.149a.32.32 0 00-.321-.32h-1.145a.21.21 0 00-.209.209v2.26z"
        fill="#FFBD86"
      />
      <Path
        d="M11.054 17.803h-.85a.21.21 0 00-.21.209v2.26h.85v-2.26a.21.21 0 01.21-.21z"
        fill="#F6A96C"
      />
      <Path
        d="M4.967 20.271H3.293v-2.15a.32.32 0 01.32-.32h1.145a.21.21 0 01.21.21v2.26z"
        fill="#FFBD86"
      />
      <Path
        d="M4.115 19.95v-1.828a.32.32 0 01.32-.32h-.821a.32.32 0 00-.321.32v2.149h1.143a.32.32 0 01-.321-.32z"
        fill="#F6A96C"
      />
      <Path
        d="M8.038 17.234h-1a.125.125 0 01-.124-.125v-1.332h1.249v1.332a.125.125 0 01-.125.125z"
        fill="#fff"
      />
      <Path
        d="M7.5 17.109v-1.332h-.586v1.332c0 .069.056.124.125.124h.586a.125.125 0 01-.125-.124z"
        fill="#F3F0FF"
      />
      <Path
        d="M5.875 14.407H4.709a.297.297 0 110-.594h1.166a.297.297 0 010 .594z"
        fill="#FFBD86"
      />
      <Path
        d="M8.396 1.99H6.602a.297.297 0 110-.594h1.794a.297.297 0 110 .594z"
        fill="#fff"
      />
    </Svg>
  );
}

export default SvgComponent;
